import { loadRecommendations } from "./einsteinUtils";

/**
 *  Init carousel for content  tiles
 */
const initCarousel = (carousel) => {
    if (carousel && carousel.length) {
        carousel.each(function () {
            const $this = $(this);
            const slidesSm = $this.data("slides-small");
            const slidesMd = $this.data("slides-medium");
            const slidesLg = $this.data("slides-large");
            const slidesArrows = $this.data("slides-arrows");
            const slidesDots = $this.data("slides-dots");

            $this.slick({
                prevArrow: "<button type='button' class='slick-prev slick-arrow-border slick-prev-out' aria-label='Previous'></button>",
                nextArrow: "<button type='button' class='slick-next slick-arrow-border slick-next-out' aria-label='Next'></button>",
                "slidesToShow": slidesSm,
                pauseOnFocus: false,
                mobileFirst: true,
                adaptiveHeight: true,
                arrows: false,
                dots: true,
                responsive: [
                    {
                        breakpoint: 544,
                        settings: {
                            slidesToShow: slidesMd
                        }
                    },
                    {
                        breakpoint: 769,
                        settings: {
                            slidesToShow: slidesLg,
                            arrows: slidesArrows,
                            dots: slidesDots
                        }
                    }
                ]
            });

            // Remove empty containers for offline products
            if ($this.hasClass("carousel-product")) {
                const $removeSlides = $this.find(".js-remove-slide");

                if ($removeSlides.length > 0) {
                    $removeSlides.parents(".slide-wrapper").each(function () {
                        let index = $(this).parents(".slick-slide").data("slick-index");
                        $this.slick("slickRemove", index);
                    });
                }
            }
        });
    }
};

/**
 * Clear the form errors.
 * @param {string} parentSelector - the parent form selector.
 */
const initFirstCarousel = () => {
    const $carouselWrapper = $(".tab-carousel-wrapper");

    $carouselWrapper.each(function () {
        const $this = $(this);
        const $contentSlider = $this.find(".js-content-tiles-carousel").first();

        if ($contentSlider.length) {
            const $layoutContainer = $contentSlider.parent();
            const einsteinRecommender = $layoutContainer.attr("data-einstein-recommender");

            if (einsteinRecommender) {
                loadRecommendations($layoutContainer, einsteinRecommender, initCarousel);
            } else {
                initCarousel($contentSlider);
            }
        }
    });
};

export const initContentTileCarousel = initCarousel;
export const initFirstContentCarousel = initFirstCarousel;
